<template>
    <span :class="className">
        <svg xmlns="http://www.w3.org/2000/svg" width="16" height="17" viewBox="0 0 16 17" fill="none">
<path :fill="fillColor" d="M13.8403 3.22664C9.71357 2.80207 8.5248 0.424592 8.47385 0.322697C8.37198 0.118944 8.18517 0 7.96435 0C7.74353 0 7.53979 0.135875 7.45485 0.322697C7.38697 0.424573 6.18128 2.80207 2.05443 3.22664C1.76574 3.26063 1.54492 3.49838 1.54492 3.80401V7.96471C1.54492 12.8557 7.43783 15.9465 7.69257 16.0823C7.77751 16.1163 7.86244 16.1502 7.94726 16.1502C8.03219 16.1502 8.13407 16.1333 8.20195 16.0823C8.45663 15.9464 14.3496 12.8726 14.3496 7.96471L14.3498 3.78703C14.3668 3.49834 14.129 3.2606 13.8403 3.22661L13.8403 3.22664ZM13.212 7.96474C13.212 11.616 9.05129 14.2652 7.94743 14.9106C6.84363 14.2652 2.68287 11.6329 2.68287 7.96474V4.29653C5.6548 3.87197 7.21718 2.47935 7.94743 1.59635C8.67761 2.47947 10.2401 3.87197 13.212 4.29653V7.96474Z" fill="#667488"/>
<path :fill="fillColor" d="M5.74023 6.18141C5.74023 7.20042 6.43654 8.04954 7.37061 8.30422V12.397C7.37061 12.7197 7.6253 12.9744 7.94798 12.9744C8.27067 12.9744 8.52536 12.7197 8.52536 12.397V11.7516H9.23862C9.56132 11.7516 9.81599 11.4969 9.81599 11.1743C9.81599 10.8516 9.5613 10.5969 9.23862 10.5969H8.52536V8.30419C9.45942 8.0495 10.1557 7.20039 10.1557 6.18138C10.1557 4.95865 9.17075 3.97363 7.94798 3.97363C6.72525 3.99069 5.74023 4.97557 5.74023 6.18138V6.18141ZM9.00086 6.18141C9.00086 6.75879 8.52536 7.23429 7.94798 7.23429C7.37061 7.23429 6.8951 6.75879 6.8951 6.18141C6.8951 5.60404 7.37061 5.12853 7.94798 5.12853C8.52536 5.12853 9.00086 5.60404 9.00086 6.18141Z" fill="#667488"/>
</svg>
</span>
</template>

<script>
export default {
    name: 'AgreementIcon',
    props: {
      fillColor: {
      type: String,
      default: "#1A73E8"
    },
    width: {
      type: String,
      default: '16px'
    },
    height: {
      type: String,
      default: '16px'
    },
    className: {
      type: String,
      default: ''
    }
  }
}
</script>

<style scoped>
/* Add any custom styles here */
</style>